import { useMemo } from "react";

import { useGetProfilesQuery } from "../../../redux/liProfileVisits/liProfileVisits.api";

import { FilterPillOption } from "../components/FilterPill";

/** Enough to list every sender of a company; the endpoint is paginated. */
const SENDER_PAGE_SIZE = 100;

/**
 * The company's users, as options for the Sender filter.
 *
 * Reuses `users/profiles` — the company-scoped endpoint the list-create and LinkedIn
 * pages already read — rather than adding an Analytics-only one.
 */
export function useSenderOptions(): { options: FilterPillOption[]; isLoading: boolean } {
	const { data, isFetching } = useGetProfilesQuery({ page: 1, limit: SENDER_PAGE_SIZE });

	const options = useMemo<FilterPillOption[]>(
		() =>
			(data?.data ?? []).map((user) => {
				const name = `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim();

				return {
					id: user.id as number,
					// A user with no name still has to be pickable, so fall back to the email.
					title: name || user.email || `User ${user.id}`,
					subtitle: name ? user.email : undefined,
				};
			}),
		[data]
	);

	return { options, isLoading: isFetching };
}
